module.exports = __webpack_public_path__ + "img/1.893875a6.png";